export default "__VITE_ASSET__CzxQaYi9__"